module.exports = __webpack_public_path__ + "img/X.90c45913.svg";